<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { ROUTES } from '@/constants/routes';

// types &  data
import type { DropdownProps } from "@/dsComponents/Dropdown/types";

// components
import Button from "@/dsComponents/buttons/Button.vue";
import ButtonAlt from "@/dsComponents/buttons/ButtonAlt.vue";
import Dropdown from "@/dsComponents/Dropdown/Dropdown.vue";

interface MissionLabelsActionsProps {
    isExpired?: boolean;
    jobOffer?: { id: string; workerToTreated: number };
    isSyncWithEvolia?: boolean;
    isExtended?: boolean;
}

const props = defineProps<MissionLabelsActionsProps>();
const router = useRouter();
const { t } = useI18n();

const dropdownActionsProps: DropdownProps = {
    mode: "hover",
    width: "fit-content",
    styles: { color: "#494E61", "font-size": "12px" },
};

const isNewWorkerToTreated = computed(() => props.jobOffer?.workerToTreated !== 0);

const handleJobOfferRedirect = () => {
    if (!props.jobOffer?.id) return;
    router.push({ name: ROUTES.APP.COMPANY_NEED.JOB_OFFERS });
};
const hasJobOffer = computed(() => !!props.jobOffer);
</script>

<template>
    <div class="mission-labels-actions">
        <Dropdown v-if="isExpired" v-bind="dropdownActionsProps" :debounce="500">
            <template #trigger-zone>
                <Button iconOnly="cal-exclamation" iconOnlyColor="#E51940" type="neutral" variant="ghost" size="xs" />
            </template>
            <template #dropdown-content>
                <span>{{ t("page.mission.kanbanCard.expiredMission") }}</span>
            </template>
        </Dropdown>
        <Dropdown v-if="hasJobOffer" v-bind="dropdownActionsProps" :debounce="500">
            <template #trigger-zone>
                <ButtonAlt
                    iconOnly="megaphone"
                    type="neutral"
                    variant="ghost"
                    size="sm"
                    :alert="isNewWorkerToTreated"
                    @click="handleJobOfferRedirect"
                />
            </template>
            <template #dropdown-content>
                <span>{{ t("page.mission.kanbanCard.jobOffer") }}</span>
            </template>
        </Dropdown>
        <Dropdown v-if="isSyncWithEvolia" v-bind="dropdownActionsProps" :debounce="500">
            <template #trigger-zone>
                <Button iconOnly="cloud-check" iconOnlyColor="#2051F8" type="neutral" variant="ghost" size="xs" />
            </template>
            <template #dropdown-content>
                <span>{{ t("page.mission.kanbanCard.syncWithEvolia") }}</span>
            </template>
        </Dropdown>
        <Dropdown v-if="isExtended" v-bind="dropdownActionsProps" :debounce="500">
            <template #trigger-zone>
                <Button iconOnly="repeat" iconOnlyColor="#2051F8" type="neutral" variant="ghost" size="xs" />
            </template>
            <template #dropdown-content>
                <span>{{ t("page.mission.kanbanCard.missionExtend") }}</span>
            </template>
        </Dropdown>
    </div>
</template>

<style scoped lang="scss">
.mission-labels-actions {
    display: flex;
    justify-content: center;
    gap: var(--spacing-xxs, 2px);
}
</style>
